import React from 'react';
import { Atom } from 'AppReact';
import { GoogleMap, Marker, withScriptjs, withGoogleMap } from 'react-google-maps';

const MyMapComponent = withScriptjs(withGoogleMap((props) => {
  return <GoogleMap
    defaultZoom={15}
    defaultCenter={{ lat: props.lat, lng: props.lng }}
  >
    <Marker options={{ icon: { url: props.propertyImage, scaledSize: { width: 60, height: 60 }, scale: 2 } }} position={{ lat: props.lat, lng: props.lng }} />
    {props.techs && props.techs.map(tech =>
      tech.lat ? <Marker key={tech.id}
        options={{ icon: { url: tech.image ?? "https://cdn3.iconfinder.com/data/icons/gray-user-toolbar/512/worker-512.png", scaledSize: { width: 20, height: 20 } } }}
        position={{ lat: parseFloat(tech.lat), lng: parseFloat(tech.lng) }} /> : null
    )}
  </GoogleMap>
}
));

const Maps = ({ property, techs }) => {
  return (
    <MyMapComponent
      googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyAr30moXrrWMfu-pyeDabgPddKzLcMJO5w"
      loadingElement={<div style={{ height: `100%` }} />}
      containerElement={<div style={{ height: `100%`, width: '100%' }} />}
      mapElement={<div style={{ height: `100%` }} />}
      lng={parseFloat(property?.lng)}
      lat={parseFloat(property?.lat)}
      techs={techs}
      propertyImage={property?.icon}
    />
  )
}


export default Atom({ type: 'custom', dataType: 'string', template: Maps });
